import { useOutletContext } from 'react-router-dom';
import ParkingArea from 'src/components/user-mobile/parking/user/ParkingArea';
import TopFixedBarParking from 'src/components/user-mobile/parking/user/TopFixedBarParking';
import UserFooter from 'src/components/user-mobile/parking/user/UserFooter';
import { IFestivalOutlet } from 'src/interfaces/overview.interface';
import { styled } from 'styled-components';

export default function Parking() {
  const { festivalId } = useOutletContext<IFestivalOutlet>();
  return (
    <>
      <TopFixedBarParking />
      <UserPageContainer>
        <ParkingArea festivalId={festivalId} />
        <UserFooter />
      </UserPageContainer>
    </>
  );
}

const UserPageContainer = styled.div`
  @media (min-width: 640px) {
    width: 640px;
    margin: 0 auto;
    background-color: #fff;
  }
`;
